/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Save_LabelInputs */

const en_cap_save_label = /** @type {(inputs: Cap_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save time`)
};

const lv_cap_save_label = /** @type {(inputs: Cap_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ietaupiet laiku`)
};

/**
* | output |
* | --- |
* | "Save time" |
*
* @param {Cap_Save_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_save_label = /** @type {((inputs?: Cap_Save_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Save_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_save_label(inputs)
	return en_cap_save_label(inputs)
});